// ============== START: Card product drag js for desktop ============
  document.addEventListener('DOMContentLoaded', () => {
    // Target all featured collection sliders
    const sliders = document.querySelectorAll('.custom-collection-slider slider-component [id^="Slider-"]');
    
    sliders.forEach(slider => {
      if (!slider) return;
      
      // enable native horizontal scroll + swipe
      slider.style.overflowX = 'auto';
      slider.style.scrollSnapType = 'x mandatory';
      slider.style.scrollBehavior = 'smooth';
      slider.style.cursor = 'grab';
      slider.style.webkitOverflowScrolling = 'touch'; // iOS momentum

      // mouse drag style feedback
      slider.addEventListener('mousedown', () => slider.style.cursor = 'grabbing');
      slider.addEventListener('mouseup', () => slider.style.cursor = 'grab');

      // optional: prevent text selection during drag
      slider.addEventListener('dragstart', e => e.preventDefault());

      // enable horizontal scroll on touch/mouse
      let isDown = false;
      let startX, scrollLeft;

      slider.addEventListener('mousedown', (e) => {
        isDown = true;
        slider.classList.add('active');
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      });
      slider.addEventListener('mouseleave', () => {
        isDown = false;
        slider.classList.remove('active');
      });
      slider.addEventListener('mouseup', () => {
        isDown = false;
        slider.classList.remove('active');
      });
      slider.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 1; // scroll speed
        slider.scrollLeft = scrollLeft - walk;
      });
    });
  });
// ============== END: Card product drag js for desktop ============

$(document).ready(function() {

  // ========== START : Menu drawer Click event =================
  $(document).on("click",".menu-drawer__navigation .icon-close",function() {
    $(this).closest('.header').find('.header__icon--menu').trigger("click"); 
  });
  // ========== END : Menu drawer Click event =================

   // ========== START : Move footer menu blocks to new wrapper =================
  var $menuWrapper = $('<div class="footer-menu-wrapper"></div>');

  $('.footer-block--menu').appendTo($menuWrapper);

  $('.footer__blocks-wrapper').append($menuWrapper);
  // ========== END : Move footer menu blocks to new wrapper =================

  // ========== START : Footer heading DropDown =================

$(document).on("click", ".footer-block__heading", function () {
  // Only apply toggle behavior on mobile (e.g., max-width 767px)
  if ($(window).width() <= 749) {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).next(".footer-block__details-content").slideUp();
    } else {
      $(".footer-block__heading").removeClass("active");
      $(".footer-block__details-content").slideUp();

      $(this).addClass("active");
      $(this).next(".footer-block__details-content").slideDown();
    }
  }
});

  // ========== END : Footer heading DropDown =================

  // ========== START : Custom Description toggle  ================
  $(document).on("click",".read-more-link", function(){
    $(this).closest(".custom-product-description").toggleClass('active');
  });
  // ========== END : Custom Description toggle  ================


  // ============= START: Trigger size option ================/
  $(document).on("change", ".product_size_selector select", function(){
    var selectedValue = $(this).val();
    var $variantContainer = $(this).closest("variant-selects").find(".product-form-size-option");
    $variantContainer.find("[data-label-value='" + selectedValue + "']").trigger("click");
  });
  // ============= END: Trigger size option ================/


$(document).on("click", ".icon-with-text__item", function(e) {
  // If click is inside popup-close-custom OR inside popup-content, remove active
  if ($(e.target).closest(".popup-close-custom").length || $(e.target).closest(".popup-content").length) {
    $(this).removeClass("active");
    if (!$(".icon-with-text__item.active").length) {
      $("body").removeClass("popup-opened");
    }
  } else {
    // Item clicked: activate this, deactivate others
    $(".icon-with-text__item").removeClass("active");
    $(this).addClass("active");
    $("body").addClass("popup-opened");
  }
});


    var $desktopSliders = $('.js-slick-desktop');
    var desktopBreakpoint = 750; // px
    var slickInitialized = false;

    function initSlickDesktop() {
      if ($(window).width() >= desktopBreakpoint && !slickInitialized) {
        $desktopSliders.slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          infinite: false,
          responsive: [
            {
              breakpoint: 1400,
              settings: {
                slidesToShow: 3,
              }
            },
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 2,
              }
            }
          ]
        });
        slickInitialized = true;
      } else if ($(window).width() < desktopBreakpoint && slickInitialized) {
        $desktopSliders.slick('unslick');
        slickInitialized = false;
      }
    }

    // Initial check
    initSlickDesktop();

    // Optional: Re-check on window resize
    $(window).on('resize', function () {
      initSlickDesktop();
    });



  function getTheCookie(name) {
  var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  if (match) return decodeURIComponent(match[2]);
  return null;
}

function setTheCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/";
}


// ===== START wishlist functions =====
function setupWishlistButtons() {
  if (
    getTheCookie("wishlist") != null &&
    getTheCookie("wishlist") != "__" &&
    getTheCookie("wishlist") != ""
  ) {
    var str = String(getTheCookie("wishlist")).split("__");
    for (var i = 0; i < str.length; i++) {
      if (str[i] != "") {
        console.log("test wishlist ", ".added-wishbutton-" + str[i]);
        document.querySelector(".added-wishbutton-" + str[i]) != null
          ? (document.querySelector(
              ".added-wishbutton-" + str[i]
            ).style.display = "flex")
          : "";
        document.querySelector(".default-wishbutton-" + str[i]) != null
          ? document.querySelector(".default-wishbutton-" + str[i]).remove()
          : "";
        document.querySelector(".loadding-wishbutton-" + str[i]) != null
          ? document.querySelector(".loadding-wishbutton-" + str[i]).remove()
          : "";
      }
    }
  }
}
function convertToMoney(price) {
  var price = parseFloat(price / 100).toFixed(2);
  var currency =
    document.getElementsByTagName("html")[0].getAttribute("currency") || "$";
  return currency + price;
}
// ===== END wishlist functions =====


  // ===== START wishlist js =======
  if ($(".product__info-container .wishlist_icon").length != 0) {
    $(document).on("click", ".product__info-container .wishlist_icon", function (event) {
      if ($(this).hasClass("added-wishlist")) return true;
      event.preventDefault();
      try {
        var id = $(this).data("wishlist");
        if (getTheCookie("wishlist") == null) {
          var str = id;
        } else {
          if (getTheCookie("wishlist").indexOf(id) == -1) {
            var str = getTheCookie("wishlist") + "__" + id;
          }
        }
        setTheCookie("wishlist", str, 14);
        $(".loadding-wishbutton-" + id).show();
        $(".default-wishbutton-" + id).remove();
        setTimeout(function () {
          $(".loadding-wishbutton-" + id).remove();
          $(".added-wishbutton-" + id).show();
        }, 2000);
      } catch (err) {
        console.log("error reading wishlist cookies!");
      }
    });
  }
  setupWishlistButtons();
  // ===== END wishlist js =======



  // ==================START : Megamenu Products Grab js =================

const carousals = document.querySelectorAll('.custom-mega-product-menu');
if (!carousals.length) return;

carousals.forEach((wrap) => {
  let isDown = false;
  let startX = 0;
  let scrollStart = 0;

  const startDrag = (x) => {
    isDown = true;
    wrap.classList.add('grabbing');
    startX = x;
    scrollStart = wrap.scrollLeft;
  };

  const dragMove = (x) => {
    if (!isDown) return;
    const dx = x - startX;
    wrap.scrollLeft = scrollStart - dx; // Direct scroll, no lag
  };

  const endDrag = () => {
    isDown = false;
    wrap.classList.remove('grabbing');
  };

  // Mouse events
  wrap.addEventListener('mousedown', (e) => startDrag(e.pageX));
  wrap.addEventListener('mousemove', (e) => dragMove(e.pageX));
  wrap.addEventListener('mouseup', endDrag);
  wrap.addEventListener('mouseleave', () => {
    if (isDown) endDrag();
  });

  // Touch events
  wrap.addEventListener('touchstart', (e) => startDrag(e.touches[0].pageX));
  wrap.addEventListener('touchmove', (e) => dragMove(e.touches[0].pageX));
  wrap.addEventListener('touchend', endDrag);
});

  // ==================END : Megamenu Products Grab js =================

  // ========== START : Header Drawer Menu  Click Js ================

$(document).on("click", ".menu-drawer__navigation ul li", function () {

  // If this li already has active, remove it (toggle off)
  if ($(this).hasClass("header-menu-open")) {
      $(this).removeClass("header-menu-open");
  } else {
      // Otherwise remove active from others and add to this
      $(".menu-drawer__navigation ul li").removeClass("header-menu-open");
      $(this).addClass("header-menu-open");
  }

});

  // ========== END : Header Drawer Menu  Click Js ================

 document.addEventListener("click", function (e) {
  const inquiryBtn = e.target.closest(".inquiry-button");

  if (!inquiryBtn) return;

  e.preventDefault();

  const floatingBtn = document.querySelector(".floating-button");

  if (floatingBtn) {
    floatingBtn.click();
  }
});

  // product page back button js
  const backBtn = document.querySelector(".back-button");
  if (!backBtn) return;
  const referrer = document.referrer;
  if (referrer && referrer.includes(window.location.hostname)) {
    backBtn.addEventListener("click", function (e) {
      e.preventDefault();
      history.back();
    });
  } else {
    backBtn.style.display = "none";
  }

});


